<template>
  <v-app id="inspire">
    <Navbar></Navbar>

    <!-- <main> -->
    <v-content class="mx-auto">
      <router-view></router-view>
    </v-content>
    <!-- </main> -->
  </v-app>
</template>

<script>
import Navbar from "@/components/Navbar";

export default {
  name: "App",
  components: {
    Navbar
  }
};
</script>

<style>
html {
  overflow-y: auto;
}
</style>
